import { useEffect } from "react";
import { getApplicationSettings } from "../../services/apiManager/apiRequests";
import apiConfig from "../../services/apiManager/apiConfig";

export const useRouteChange = ({ event1 }) => {
  const pathName = window.location?.pathname;
  const triggerAppSetting = async () => {
    const resp = await getApplicationSettings(apiConfig.appSettings);
    if (event1) {
      event1(resp?.appSettings);
    }
  };
  useEffect(() => {
    // EVENT_1
    triggerAppSetting();

    // EVENT2
    //if we want to add event 2  on every route chnage we can add here ....
  }, [pathName]);

  return { event1 };
};
